import { BaseQueryApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { AppState } from '~/reducers';
import { getDiamGroupId } from '~/domain/uptime/utils/utils';

const prepareBaseHeaders = (
  headers: Headers,
  api: Pick<BaseQueryApi, 'getState' | 'extra' | 'endpoint' | 'type' | 'forced'>
) => {
  const timestamp = (api.getState() as AppState)?.app?.timestamp;
  if (timestamp) {
    headers.set('x-app-timestamp', timestamp);
  }
  const groupId = getDiamGroupId();
  if (groupId !== undefined) {
    headers.set('x-diam-group-id', groupId);
  }
  headers.set('Content-Type', 'application/json');
  headers.set('Accept', 'application/json');
  return headers;
};

export const authenticatedBaseQuery = fetchBaseQuery({
  baseUrl: `${process.env.ENDPOINT_BFF}/fleet/secure`,
  prepareHeaders: (headers, api) => {
    prepareBaseHeaders(headers, api);
  },
});
export const authenticatedBaseMobileQuery = fetchBaseQuery({
  baseUrl: `${process.env.ENDPOINT_BFF}/mobile`,
  prepareHeaders: (headers, api) => {
    prepareBaseHeaders(headers, api);
  },
});

export const publicBaseQuery = fetchBaseQuery({
  baseUrl: `${process.env.ENDPOINT_BFF}/fleet/public`,
  prepareHeaders: prepareBaseHeaders,
});

export const publicLicensesQuery = fetchBaseQuery({
  baseUrl: `${process.env.MEDIA_BUCKET_BASE_URL}/licenses`,
});
